var map = {
	"./Dictionary": [
		"./src/locales/Dictionary.jsx",
		9
	],
	"./Dictionary.jsx": [
		"./src/locales/Dictionary.jsx",
		9
	],
	"./QUESTIONNAIRE-TOOL_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_DE.json",
		3
	],
	"./QUESTIONNAIRE-TOOL_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_DE.json",
		3
	],
	"./QUESTIONNAIRE-TOOL_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_EN.json",
		3
	],
	"./QUESTIONNAIRE-TOOL_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_EN.json",
		3
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_DE.json",
		3,
		3
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_DE.json",
		3,
		3
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_EN.json",
		3,
		4
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_EN.json",
		3,
		4
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_DE.json",
		3,
		5
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_DE.json",
		3,
		5
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_EN.json",
		3,
		6
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_EN.json",
		3,
		6
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_DE.json",
		3,
		7
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_DE.json",
		3,
		7
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_EN.json",
		3,
		8
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_EN.json",
		3,
		8
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_MAP.json",
		3,
		9
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_MAP.json",
		3,
		9
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_DE.json",
		3,
		10
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_DE.json",
		3,
		10
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_EN.json",
		3,
		11
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_EN.json",
		3,
		11
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_MAP.json",
		3,
		12
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_LIGHT_PEER_MAP.json",
		3,
		12
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_MAP.json",
		3,
		13
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_MAP.json",
		3,
		13
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_DE.json",
		3,
		14
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_DE.json",
		3,
		14
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_EN.json",
		3,
		15
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_EN.json",
		3,
		15
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_MAP.json",
		3,
		16
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_FORSCHUNG_PEER_MAP.json",
		3,
		16
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_MAP.json",
		3,
		17
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_MAP.json",
		3,
		17
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_DE": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_DE.json",
		3,
		18
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_DE.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_DE.json",
		3,
		18
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_EN": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_EN.json",
		3,
		19
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_EN.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_EN.json",
		3,
		19
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_MAP": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_MAP.json",
		3,
		20
	],
	"./QUESTIONNAIRE-TOOL_TUM_USER_PEER_MAP.json": [
		"./src/locales/QUESTIONNAIRE-TOOL_TUM_USER_PEER_MAP.json",
		3,
		20
	],
	"./questionnaireDBMap": [
		"./src/locales/questionnaireDBMap.json",
		3
	],
	"./questionnaireDBMap.json": [
		"./src/locales/questionnaireDBMap.json",
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;